import { category_infos, games_infos } from '../assets/gameinfos.js';

// 辅助函数：随机打乱数组（Fisher-Yates 洗牌算法）
function shuffleArray(array) {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
}

// 在模块加载时就打乱游戏列表
let shuffledGames = shuffleArray(games_infos.gameList);

export default {
    // 拉取游戏列表
    getGameList(start = 0, size = 20, type = 0, name = '', hot = -1, recommond = -1) {
        // let filteredGames = [...games_infos.gameList];
        let filteredGames = [...shuffledGames]; // 使用已经打乱的游戏列表
        // Apply filters
        if (type !== 0) {
            filteredGames = filteredGames.filter(game =>
                game.category.includes(type.toString().padStart(2, '0'))
            );
        }

        if (name) {
            filteredGames = filteredGames.filter(game =>
                game.gname.toLowerCase().includes(name.toLowerCase())
            );
        }

        if (hot === 1) {
            // Since we don't have hot data, we'll just return a subset
            filteredGames = filteredGames.slice(0, 50);
        }

        if (recommond === 1) {
            // Since we don't have recommond data, we'll just return a subset
            filteredGames = filteredGames.slice(0, 30);
        }

        // Apply pagination
        const paginatedGames = filteredGames.slice(start, start + size);

        // Map to expected format
        const result = paginatedGames.map(game => ({
            id: game.id,
            name: game.gname,
            icon: game.icon,
            playUrl: game.url,
            recommond: recommond === 1 ? 1 : 0,
            hot: hot === 1 ? 1 : 0,
            playNum: Math.floor(Math.random() * 10000), // Random play count since we don't have this data
            state: 0, // Assuming all games are in normal state
            types: game.category.map(catId => {
                const category = category_infos.categoryList.find(c => c.id === catId);
                return category ? { id: catId, name: category.cnName } : null;
            }).filter(Boolean)
        }));

        let resp = {
            status: 200,
            data: {
                code: 0,
                data: {
                    items: result
                }
            }
        }

        return Promise.resolve(resp);
    },

    // 拉取游戏类型列表
    getCategories() {
        const result = category_infos.categoryList.map(category => ({
            id: category.id,
            name: category.name,
            total: games_infos.gameList.filter(game =>
                game.category.includes(category.id)
            ).length
        }));

        let resp = {
            status: 200,
            data: {
                code: 0,
                data: {
                    items: result
                }
            }
        }

        return Promise.resolve(resp);
    },

    // 游戏入口
    getGame(gameId) {
        const game = games_infos.gameList.find(g => g.id === gameId);
        if (!game) {
            return Promise.reject(new Error('Game not found'));
        }

        const result = {
            id: game.id,
            url: game.url,
            res: null, // Not available in local data
            resmd5: null, // Not available in local data
            reslibs: [] // Not available in local data
        };

        let resp = {
            status: 200,
            data: {
                code: 0,
                data: result
            }
        }

        return Promise.resolve(resp);
    },

    // 拉取游戏信息
    getGamesInfo(ids) {
        const result = games_infos.gameList
            .filter(game => ids.includes(game.id))
            .map(game => ({
                id: game.id,
                name: game.gname,
                icon: game.icon,
                playUrl: game.url,
                recommond: 0, // Default value
                hot: 0, // Default value
                playNum: Math.floor(Math.random() * 10000), // Random play count
                state: 0, // Assuming normal state
                types: game.category.map(catId => {
                    const category = category_infos.categoryList.find(c => c.id === catId);
                    return category ? { id: catId, name: category.cnName } : null;
                }).filter(Boolean)
            }));
        
        // let resp = {
        //     status: 200,
        //     data: {
        //         code: 0,
        //         data: result
        //     }
        // }

        return Promise.resolve(result);
    },

    // 拉取游戏详情
    getGameInfo(id) {
        const game = games_infos.gameList.find(g => g.id === id);
        if (!game) {
            return Promise.reject(new Error('Game not found'));
        }

        const result = {
            id: game.id,
            name: game.gname,
            icon: game.icon,
            playUrl: game.url,
            recommond: 0, // Default value
            hot: 0, // Default value
            playNum: Math.floor(Math.random() * 10000), // Random play count
            state: 0, // Assuming normal state
            types: game.category.map(catId => {
                const category = category_infos.categoryList.find(c => c.id === catId);
                return category ? { id: catId, name: category.cnName } : null;
            }).filter(Boolean),
            des: game.des // Adding description from local data
        };

        let resp = {
            status: 200,
            data: {
                code: 0,
                data: result
            }
        }

        return Promise.resolve(resp);
    }
}
